import { Injectable } from '@angular/core';
import { catchError, map, mergeMap } from 'rxjs/operators';
import { forkJoin, of } from 'rxjs';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { AppState } from '../../reducers';
import {
  FireReasonSuccess,
  ReasonActionTypes,
  ReasonDeleted,
  ReasonOnServerDeleted,
  ReasonsActionToggleLoading,
  ReasonsPageCancelled,
  ReasonsPageLoaded,
  ReasonsPageRequested,
  ReasonsPageToggleLoading,
  ThrowReasonError,
} from '../_actions/reason.actions';
import { Router } from '@angular/router';
import { AuthService } from '../../auth';
import { ReasonService } from '../_services/reasons.service';

@Injectable()
export class ReasonEffects {
  showPageLoadingDistpatcher = new ReasonsPageToggleLoading({ isLoading: true });
  hidePageLoadingDistpatcher = new ReasonsPageToggleLoading({ isLoading: false });
  showActionLoadingDistpatcher = new ReasonsActionToggleLoading({ isLoading: true });
  hideActionLoadingDistpatcher = new ReasonsActionToggleLoading({ isLoading: false });

  @Effect()
  loadReasonsPage$ = this.actions$.pipe(
    ofType<ReasonsPageRequested>(ReasonActionTypes.ReasonsPageRequested),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showPageLoadingDistpatcher);
      const requestToServer = this.reason.findReasons(payload.page);
      const lastQuery = of(payload.page);
      return forkJoin([requestToServer, lastQuery]).pipe(
        catchError((error) => {
          return of([error]);
        }),
        map((response) => {
          if (response[0] && response[0].error) {
            if (response[0].status === 401) {
              return response[0];
            } else if (response[0].status === 403) {
              this.router.navigateByUrl('/error/403');
              return new ReasonsPageCancelled();
            } else {
              this.store.dispatch(new ThrowReasonError({ error: response[0].error.error }));
              return new ReasonsPageCancelled();
            }
          } else {
            const result = response[0];
            return new ReasonsPageLoaded({
              reasons: result.data,
              totalCount: result.count,
              page: response[1],
            });
          }
        }),
      );
    }),
  );

  @Effect()
  deleteReason$ = this.actions$.pipe(
    ofType<ReasonOnServerDeleted>(ReasonActionTypes.ReasonOnServerDeleted),
    mergeMap(({ payload }) => {
      this.store.dispatch(this.showActionLoadingDistpatcher);
      return this.reason.deleteReason(payload.id).pipe(
        catchError((error) => {
          return of({ error });
        }),
        map((res) => {
          if (res && res.error) {
            return new ThrowReasonError({ error: res.error });
          } else {
            this.store.dispatch(this.hideActionLoadingDistpatcher);
            this.store.dispatch(
              new FireReasonSuccess({ action_type: ReasonActionTypes.ReasonDeleted }),
            );
            return new ReasonDeleted(payload);
          }
        }),
      );
    }),
  );

  constructor(
    private actions$: Actions,
    private reason: ReasonService,
    private store: Store<AppState>,
    private router: Router,
    private authService: AuthService,
  ) {}
}
